/* 168VELO — scratch-off reveal
   <scratch-reveal data-coat="rgba(26,26,26,.98)" data-texture="grain.png" data-hint="#id" [data-lock-touch]>
     <canvas></canvas>
   </scratch-reveal>
   The element is sized by CSS; the canvas follows it and keeps what has
   been scratched when it resizes. */
(function () {
  if (customElements.get('scratch-reveal')) return;

  var TEXTURE_ALPHA = 0.05; // faint matte grain on the coating
  var DOT_ALPHA = 1; // a tap clears the centre outright
  var MOVE_ALPHA = 0.45; // strength of each stamp along a drag
  var STEP = 0.22; // stamp spacing along a drag, as a fraction of R

  class ScratchReveal extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      if (!this.canvas || this._ready) return;
      this._ready = true;
      this.ctx = this.canvas.getContext('2d');
      this.coat = this.dataset.coat || 'rgba(26, 26, 26, 0.98)';
      this.hint = this.dataset.hint ? document.querySelector(this.dataset.hint) : null;
      this.W = 0;
      this.H = 0;
      this.dpr = 1;
      this.R = 48;
      this.texture = null;
      this.brush = null;
      this.activeId = null;
      this.lx = 0;
      this.ly = 0;
      this.scratched = false;

      this.resize();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.resize());
        this.ro.observe(this);
      } else {
        window.addEventListener('resize', () => this.resize());
      }

      if (this.dataset.texture) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          this.texture = img;
          this.applyTexture();
        };
        img.src = this.dataset.texture;
      }

      this.bindPointer();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    brushRadius() {
      return Math.round(Math.max(40, Math.min(95, Math.min(this.W, this.H) * 0.1)));
    }

    // A radial sprite that erases fully at the centre and falls off to
    // nothing at the rim, so a touch pulses out instead of stamping a disc.
    buildBrush() {
      var size = Math.max(2, Math.ceil(this.R * 2 * this.dpr));
      var half = size / 2;
      var brush = document.createElement('canvas');
      brush.width = brush.height = size;
      var b = brush.getContext('2d');
      var g = b.createRadialGradient(half, half, 0, half, half, half);
      g.addColorStop(0.0, 'rgba(0, 0, 0, 1)');
      g.addColorStop(0.2, 'rgba(0, 0, 0, 0.96)');
      g.addColorStop(0.4, 'rgba(0, 0, 0, 0.66)');
      g.addColorStop(0.6, 'rgba(0, 0, 0, 0.34)');
      g.addColorStop(0.8, 'rgba(0, 0, 0, 0.12)');
      g.addColorStop(1.0, 'rgba(0, 0, 0, 0)');
      b.fillStyle = g;
      b.fillRect(0, 0, size, size);
      this.brush = brush;
    }

    stamp(x, y, alpha) {
      if (!this.brush) return;
      var ctx = this.ctx;
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = alpha;
      ctx.drawImage(this.brush, x - this.R, y - this.R, this.R * 2, this.R * 2);
      ctx.restore();
    }

    // draws the grain only where coating still exists
    applyTexture() {
      if (!this.texture) return;
      var ctx = this.ctx;
      ctx.save();
      ctx.globalCompositeOperation = 'source-atop';
      ctx.globalAlpha = TEXTURE_ALPHA;
      ctx.fillStyle = ctx.createPattern(this.texture, 'repeat');
      ctx.fillRect(0, 0, this.W, this.H);
      ctx.restore();
    }

    paintCoating() {
      var ctx = this.ctx;
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.fillStyle = this.coat;
      ctx.fillRect(0, 0, this.W, this.H);
      ctx.restore();
      this.applyTexture();
    }

    // size the canvas to the element; keep what's been scratched so far
    resize() {
      var rect = this.getBoundingClientRect();
      var w = Math.round(rect.width);
      var h = Math.round(rect.height);
      if (!w || !h || (w === this.W && h === this.H)) return;
      var snap = null;
      if (this.W && this.H) {
        snap = document.createElement('canvas');
        snap.width = this.canvas.width;
        snap.height = this.canvas.height;
        snap.getContext('2d').drawImage(this.canvas, 0, 0);
      }
      this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.W = w;
      this.H = h;
      this.canvas.width = Math.round(w * this.dpr);
      this.canvas.height = Math.round(h * this.dpr);
      this.canvas.style.width = w + 'px';
      this.canvas.style.height = h + 'px';
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
      this.R = this.brushRadius();
      this.buildBrush();
      if (snap) {
        this.ctx.save();
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.drawImage(snap, 0, 0, this.W, this.H);
        this.ctx.restore();
      } else {
        this.paintCoating();
      }
    }

    local(e) {
      var r = this.canvas.getBoundingClientRect();
      return [e.clientX - r.left, e.clientY - r.top];
    }

    // stamp along the segment so a drag reads as a continuous stroke
    strokeTo(x, y) {
      var dx = x - this.lx;
      var dy = y - this.ly;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var n = Math.max(1, Math.ceil(dist / Math.max(1, this.R * STEP)));
      for (var i = 1; i <= n; i++) {
        this.stamp(this.lx + (dx * i) / n, this.ly + (dy * i) / n, MOVE_ALPHA);
      }
      this.lx = x;
      this.ly = y;
    }

    firstScratch() {
      if (this.scratched) return;
      this.scratched = true;
      if (this.hint) this.hint.classList.add('is-hidden');
      this.dispatchEvent(new CustomEvent('reveal:start', { bubbles: true }));
    }

    bindPointer() {
      var c = this.canvas;
      var lockTouch = this.hasAttribute('data-lock-touch');

      c.addEventListener('pointerdown', (e) => {
        if (this.activeId !== null) return; // one finger / button at a time
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.activeId = e.pointerId;
        if (e.pointerType === 'mouse' || lockTouch) {
          try {
            c.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
        var p = this.local(e);
        this.lx = p[0];
        this.ly = p[1];
        this.stamp(this.lx, this.ly, DOT_ALPHA);
        this.firstScratch();
        if (e.pointerType === 'mouse' || lockTouch) e.preventDefault();
      });

      c.addEventListener('pointermove', (e) => {
        if (e.pointerId !== this.activeId) return;
        var pts = e.getCoalescedEvents ? e.getCoalescedEvents() : null;
        if (!pts || !pts.length) pts = [e];
        for (var i = 0; i < pts.length; i++) {
          var p = this.local(pts[i]);
          this.strokeTo(p[0], p[1]);
        }
      });

      var release = (e) => {
        if (e && e.pointerId !== undefined && e.pointerId !== this.activeId) return;
        this.activeId = null;
      };
      c.addEventListener('pointerup', release);
      c.addEventListener('pointercancel', release);
      window.addEventListener('blur', () => {
        this.activeId = null;
      });
    }
  }

  customElements.define('scratch-reveal', ScratchReveal);
})();
